<script>
  import solicitacaoCompraServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';
  import $ from 'jquery';
  import Paginacao from '~componentes/Paginacao.vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import Radio from '~componentes/Radio.vue';
  import ModalStatusItem from './compartilhado/ModalStatusItem.vue';
  import ModalLiberarCancelar from '~componentes/ModalLiberarCancelar.vue';
  import ModalObservacaoCompra from '~componentes/ModalObservacaoCompra.vue';
  import BotaoReenviarEmail from '~componentes/BotaoReenviarEmail.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalProtocolos from '~componentes/ModalProtocolos.vue';
  import DatePicker from 'vue2-datepicker';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import tipoUsuario from '~js/tipo-usuario';

  export default {
    components: { Paginacao, Radio, ModalStatusItem, ModalObservacaoCompra, ModalLiberarCancelar, BotaoReenviarEmail, ModalArquivosSolicitacao, ModalProtocolos, DatePicker, ModalMensagem },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        solicitacoes: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        modalLiberarCancelar: false,
        modalArquivos: false,
        modalProtocolos: false,
        modalObservacaoCompra: false,
        solicitacaoSelecionada: null,
        salvandoLiberacao: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        modalStatusItens: false,
        modalMensagem: false,
        carregandoModalStatusItens: false,
        itens: [],
      }
    },
    computed: {
      funcionario() {
        return this.usuario.tipoUsuario == tipoUsuario.Funcionario; 
      },
    },
    methods: {
      nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
      camposFiltros() {
        return {
          tipo: 1,
          idProjeto: '',
          mostrarSolicitacoes: '0',
          periodo: '',
          codigo: '',
          valor: '',
          filtrado: false,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      filtrar() {
        this.filtros.filtrar = true;
        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return solicitacaoCompraServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.solicitacoes = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("SolCompras")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      mostrarModalLiberarCancelar(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalLiberarCancelar = true;
      },
      mostrarModalObservacaoCompra(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalObservacaoCompra = true;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      mostrarModalStatusItens(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalStatusItens = true;

        this.carregarStatusItens();
      },
      mostrarModalProtocolos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalProtocolos = true;
      },
      mostrarModalStatusItens(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalStatusItens = true;

        this.carregarStatusItens();
      },
      carregarStatusItens() {
        this.carregandoModalStatusItens = true;

        solicitacaoCompraServico
          .statusItens(this.solicitacaoSelecionada.idSolicitacaoCompra)
          .then(itens => {
            this.itens = itens;

            this.carregandoModalStatusItens = false;
          });
      },
      modalStatusItensFechado() {
        this.animated = false;
        this.modalStatusItens = false;
        this.itens = [];
        this.solicitacaoSelecionada = null;
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
      },
      modalObservacaoCompraFechado() {
        this.animated = false;
        this.modalObservacaoCompra = false;
        this.solicitacaoSelecionada = null;
      },
      liberar() {
        this.salvandoLiberacao = true;

        solicitacaoCompraServico
          .liberar(this.solicitacaoSelecionada.idSolicitacaoCompra)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.liberado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoCompra} liberada com sucesso.`);
            } else if (status.pendente) {
              toastr.warning(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoCompra} está pendente não é possível liberar.`);
            } else if (status.reinserida) {
              toastr.warning(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoCompra} está pendente de edição não é possível liberar.`);
            } else {
              toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      cancelar() {
        this.salvandoLiberacao = true;

        solicitacaoCompraServico
          .cancelar(this.solicitacaoSelecionada.idSolicitacaoCompra)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.cancelado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoCompra} cancelada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      liberadoOuCancelado(solicitacao) {
        return !!solicitacao.liberacaoCoordenador || !!solicitacao.statusSolicitacao;
      },
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
      status(solicitacao) {
        if (this.fusp()) {
          if (solicitacao.statusFUSP === '1') {
            return 'Cancelada Pelo Coordenador';
          } else if (solicitacao.statusFUSP === '2') {
            if (solicitacao.solicitacaoReinserida > 0) {
                return 'Solicitante deve alterar';
            }
            else {
              return 'Aguardando Liberação Coordenador';
            }
          } else if (solicitacao.statusFUSP === '3') {
            return 'Liberada Pelo Coordenador';
          } else if (solicitacao.statusFUSP === '4') {
            return 'Aguardando Avaliação por Compras E Contratos';
          } else if (solicitacao.statusFUSP === '5') {
            return 'Em Análise Setor de Compras e Contratos';
          } else if (solicitacao.statusFUSP === '6') {
            if (solicitacao.quantidadePedidoDisponivel > 0)
                return 'Pedido de Compra Disponível';
            else
                return 'Pedido de Compra Cancelado';
          } else if (solicitacao.statusFUSP === '7') {
            return 'Cancelada pela fundação';
          } else {
            return '';
          }
        } else {
          if (solicitacao.statusFUSP === '1') {
            return 'Cancelada Pelo Coordenador';
          } else if (solicitacao.statusFUSP === '2') {
            if (solicitacao.solicitacaoReinserida > 0) {
                return 'Solicitante deve alterar';
            }
            else {
              return 'Aguardando Liberação Coordenador';
            }
          } else if (solicitacao.statusFUSP === '3') {
            return 'Liberada Pelo Coordenador';
          } else if (solicitacao.statusFUSP === '4') {
            return 'Liberada Pelo Coordenador';//return 'Setor de Compras';
          } else if (solicitacao.statusFUSP === '5') {
            return 'Liberada Pelo Coordenador';//return 'Setor de Compras com Pedido';
          } else if (solicitacao.statusFUSP === '7') {
            return 'Cancelada pela fundação';
          } else {
            return '';
          }
        }
      },
      carregarStatusItens() {
        this.carregandoModalStatusItens = true;

        solicitacaoCompraServico
          .statusItens(this.solicitacaoSelecionada.idSolicitacaoCompra)
          .then(itens => {
            this.itens = itens;

            this.carregandoModalStatusItens = false;
          });
      },
      modalStatusItensFechado() {
        this.animated = false;
        this.modalStatusItens = false;
        this.itens = [];
        this.solicitacaoSelecionada = null;
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      modalProtocolosFechado() {
        this.animated = false;
        this.modalProtocolos = false;
        this.solicitacaoSelecionada = null;
      },
      reemviarEmail(id) {
        return solicitacaoCompraServico.reenviarEmail(id);
      },
      erroReemviarEmail(erro, id) {
        toastr.error(`Erro ao reenviar o e-mail da solicitação nº ${id}`);
      },
      enviadoReemviarEmail(id) {
        toastr.success(`E-mail da solicitação nº ${id} reenviado com sucesso.`);
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
      mostrarObservacaoCompra(solicitacao) {
        return this.configuracao.informarPendenciaSolCompra == 1 && solicitacao.observacaoSolicitacao != '';
      },
    },
    created() {
      if (this.$route.params.filtrosBag) 
        this.filtros = this.$route.params.filtrosBag;

      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Compra - Lista';
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-compra.nova';

      this.$root.botaoRetrocederMostrar = false;

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });

      if (this.$route.params.filtrosBag)
        if (this.filtros.filtrar)
          $('.ibox').removeClass('collapsed');
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .observacaoCompra {
    font-size: 1.50em;
    color: #e90015;
    margin-left: 3px;
  }



  .solicitacao-reinserida{
    color: #e90015;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-liberar-cancelar :mostrar="modalLiberarCancelar"
                            :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                            :salvando="salvandoLiberacao"
                            :liberando="configuracao.solCompraMsgConfirmacao ? false : true"
                            :mensagem="configuracao.solCompraMsgConfirmacao"
                            @fechado="modalLiberarCancelarFechado"
                            @liberar="liberar"
                            @cancelar="cancelar">
    </modal-liberar-cancelar>

    <modal-observacao-compra  :mostrar="modalObservacaoCompra"
                              :observacao="solicitacaoSelecionada ? solicitacaoSelecionada.observacaoSolicitacao : ''"
                              @fechado="modalObservacaoCompraFechado">
    </modal-observacao-compra>

    <modal-status-item :mostrar="modalStatusItens"
                       @fechado="modalStatusItensFechado"
                       :itens="itens"
                       :carregando="carregandoModalStatusItens"
                       :solicitacao="solicitacaoSelecionada">
    </modal-status-item>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                                tipo="compra"
                                :idProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.idProtocolo : ''"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-protocolos :mostrar="modalProtocolos"
                      :numeroProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.numeroProtocolo : ''"
                      @fechado="modalProtocolosFechado">
    </modal-protocolos>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                    tipo="SolCompra"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-2">
                <div class="form-group">
                  <label class="control-label" for="valor">Valor (R$)</label>

                  <input type="text"
                         class="form-control text-right"
                         id="valor"
                         v-model="filtros.valor"
                         data-vv-name="valor"
                         v-mascara="'moeda'">
                </div>
              </div>

              <div class="col-xs-10">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="codigo">Código da solicitação</label>

                  <input type="text"
                         class="form-control"
                         id="codigo"
                         v-model="filtros.codigo"
                         v-numero>
                </div>
              </div>
              <div class="col-xs-8">
                <div class="form-group">
                  <label class="control-label block">Mostrar solicitações</label>

                  <radio v-model="filtros.mostrarSolicitacoes"
                         selected-value="0"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Todas
                  </radio>
                  <radio v-model="filtros.mostrarSolicitacoes"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Aguardando liberação
                  </radio>
                  <radio v-model="filtros.mostrarSolicitacoes"
                         selected-value="2"
                         type="success"
                         :inline="true">
                    Liberadas
                  </radio>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-search"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th v-if="!configuracao.naoUtilizarMensageria">Mensagens</th>
                    <th class="text-center">Número</th>
                    <th v-if="configuracao.solicitacaoUtilizaSelecaoTipoCompra && configuracao.permitirApenasUmTipoItemSolicitacaoCompra">Tipo compra</th>
                    <th>Data solicitação</th>
                    <th>Nome solicitante</th>
                    <th>Projeto</th>
                    <th>Valor (R$)</th>
                    <th v-if="configuracao.criarProtocoloSolicitacao">Protocolo</th>
                    <th>Status solicitação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(solicitacao, index) in solicitacoes" :class="{'solicitacao-reinserida': solicitacao.solicitacaoReinserida}">
                    <td v-if="!configuracao.naoUtilizarMensageria">
                      <div v-if="solicitacao.quantidadeNaoLida > 0">
                        <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{solicitacao.quantidadeNaoLida}}
                      </div>
                    </td>
                    <td class="text-center">
                      {{ solicitacao.idSolicitacaoCompra || '---' }}
                      <i class="fa fa-exclamation-circle observacaoCompra" v-tooltip="'Clique para ler a pendência'" v-if="mostrarObservacaoCompra(solicitacao)" @click="mostrarModalObservacaoCompra(solicitacao)"></i>
                    </td>
                    <td v-html="nl2br(solicitacao.webTipoCompra)" v-if="configuracao.solicitacaoUtilizaSelecaoTipoCompra && configuracao.permitirApenasUmTipoItemSolicitacaoCompra">{{ nl2br(solicitacao.webTipoCompra) }}</td>
                    <td>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</td>
                    <td>{{ solicitacao.nomeSolicitante || '---' }}</td>
                    <td>{{ solicitacao.nomeProjeto || '---' }}</td>
                    <td>{{ solicitacao.valor | formatarNumero }}</td>
                    <td v-if="configuracao.criarProtocoloSolicitacao">
                      <a @click.prevent="mostrarModalProtocolos(solicitacao)" v-if="solicitacao.numeroProtocolo">{{ solicitacao.numeroProtocolo }} <i class="fa fa-external-link"></i></a>
                      <span v-if="!solicitacao.numeroProtocolo">---</span>
                    </td>
                    <td>{{ status(solicitacao) }}</td>
                    <td>
                      <router-link class="btn btn-primary btn-xs"
                                   active-class=""
                                   v-tooltip="'Relatório'"
                                   :to="{ name: 'solicitacao-compra.relatorio', params: { id: solicitacao.idSolicitacaoCompra , filtrosBag: filtros } }">
                        <i class="fa fa-file-text-o"></i>
                      </router-link>

                      <router-link v-if="!funcionario"
                                   tag="button"
                                   :disabled="liberadoOuCancelado(solicitacao)"
                                   class="btn btn-secondary btn-xs"
                                   active-class=""
                                   v-tooltip="'Editar'"
                                   :to="{ name: 'solicitacao-compra.editar', params: { id: solicitacao.idSolicitacaoCompra, idCript:  solicitacao.idSolicitacao } }">
                        <i class="fa fa-pencil"></i>
                      </router-link>

                      <button v-if="!configuracao.usoEmailLiberarSolicitacao"
                              :disabled="liberadoOuCancelado(solicitacao)"
                              class="btn btn-warning btn-xs"
                              v-tooltip="'Liberar ou Cancelar solicitação'"
                              @click="mostrarModalLiberarCancelar(solicitacao)">
                        <i class="fa fa-check"></i>
                      </button>

                      <botao-reenviar-email v-if="configuracao.usoEmailLiberarSolicitacao"
                                            :disabled="liberadoOuCancelado(solicitacao)"
                                            :servico="reemviarEmail"
                                            :id="solicitacao.idSolicitacaoCompra"
                                            @erro="erroReemviarEmail"
                                            @enviado="enviadoReemviarEmail">
                      </botao-reenviar-email>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                              @click="mostrarModalArquivos(solicitacao)"
                              v-if="configuracao.usarArquivosSolicitacaoCompras">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button class="btn btn-danger btn-xs"
                              v-tooltip="'Verificar status dos itens da solicitação'"
                              @click="mostrarModalStatusItens(solicitacao)"
                              v-if="configuracao.utilizarAcompanhamentoItemCompra">
                        <i class="fa fa-truck"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              @click="mostrarModalMensagem(solicitacao)"
                              v-if="!configuracao.naoUtilizarMensageria">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="9">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/SolicitacaoCompraLista.vue